/**
 * PDP / quick-buy colour-sibling swap (custom.color_variants).
 *
 * <color-variant-chips> wraps the sibling swatch links rendered by
 * snippets/color-variant-chip.liquid (pdp mode). Instead of navigating,
 * a chip click rides Dawn's combined-listing swap path: it publishes the
 * same pub/sub event variant-selects publishes, with the chip (carrying
 * data-product-url) as the target. product-info.js then fetches the
 * sibling product and swaps it in place — full <main> swap plus URL/title
 * update on the PDP (data-update-url="true"), contained swap inside the
 * quick-add modal (where quick-add.js forces data-update-url="false") —
 * so the gallery, price, and product form all become the sibling's and
 * add-to-cart adds that product. The chip's href is the no-JS fallback.
 *
 * The swap fetch deliberately carries NO ?option_values=. The current
 * product's option-value ids mean nothing to the sibling, and sending the
 * sibling's own colour id instead is worse than sending nothing: it is a
 * PARTIAL option set, and Shopify completes the rest server-side, so
 * product.selected_variant comes back as colour + FIRST size and the
 * sibling renders with the lowest size pre-checked (the checked state in
 * product-variant-options.liquid keys off has_explicit_selection). The
 * shopper never chose that size — a PDP must open, and stay, on "choose a size".
 * Omitting the param is safe for a one-variant sibling too, because
 * require_variant_selection in buy-buttons.liquid only demands a choice
 * when product.variants.size > 1.
 */
if (!customElements.get('color-variant-chips')) {
  customElements.define(
    'color-variant-chips',
    class ColorVariantChips extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onChipClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onChipClick);
      }

      onChipClick = (event) => {
        const chip = event.target.closest('.color-variant-chips__chip');
        if (!chip) return;

        if (chip.classList.contains('is-active')) {
          event.preventDefault();
          return;
        }

        // No product-info ancestor means nothing to swap — let the link navigate.
        if (!this.closest('product-info')) return;

        event.preventDefault();

        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target: chip,
            // Empty on purpose — see the note at the top of this file.
            selectedOptionValues: [],
          },
        });
      };
    }
  );
}
